export enum EventOverlapType {
  existingEvent = 'existingEvent',
  futureEvent = 'futureEvent',
}
